<div class="modal-header">
  <h4 class="modal-title">История на обновяванията</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  <p><strong class="text-muted">Артикул: </strong>{{ adTitle }}</p>
  <hr>
  @if (loading) {
    <div>
      <div class="text-center">
        <h3>
          <i class="text-muted fa-solid fa-spinner fa-spin"></i>
        </h3>
        <h5 class="text-muted">Зареждане...</h5>
      </div>
    </div>
  } @else {
    <table class="mb-0 table table-light table-striped table-hover">
      <thead>
      <tr>
        <th class="text-nowrap" scope="col">Вид обновяване</th>
        <th class="text-nowrap text-end" scope="col">Дата и час</th>
      </tr>
      </thead>
      <tbody>
        @for (renewal of renewals; track renewal.adRenewalId) {
          <tr>
            <td class="align-middle ">
              <h6 class="m-0 d-flex gap-1 align-items-center">
                {{ renewal.adRenewalTypeName }}
              </h6>
            </td>
            <td class="align-middle text-muted text-end small">
              <div class="text-nowrap">{{ renewal.renewalDate | date:'dd.MM.yyyy г.' }}</div>
              <div class="text-nowrap">{{ renewal.renewalDate | date:'HH:mm:ss ч.' }}</div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
</div>
